// CheckoutForm.js
import React, { Fragment } from 'react';
import { injectStripe } from 'react-stripe-elements';
import { postData } from '../../utils/request';
import CardSection from './CardSection';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Loading from '../shared/Loading';
import Button from '../../artzu-ui/src/Button';
import TextField from '../../artzu-ui/src/TextField';
import { withApollo } from 'react-apollo';
// import './profile.css';

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinning: false,
      paying: false,
      name: `${this.props.firstName} ${this.props.lastName}`,
      negative: true,
      owing: this.props.owing
        ? 'Thank you, your payment has been processed.'
        : `Outstanding balance: $${this.props.amount.toFixed(2)}`,
      partial: false,
      partialAmount: null,
      financing: false
    };
  }
  handleSubmit = ev => {
    const { amount } = this.props;
    const {
      partial,
      partialAmount
    } = this.state;
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();
    this.setState({ spinning: true });
    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    this.props.stripe
      .createToken({
        name: this.state.name || 'John Doe',
        email: this.props.email,
      })
      .then(({ token }) => {
        // MAKE BACKEND CALL HERE
        postData('charges', {
          token,
          amount: partial ? partialAmount : amount,
          name: this.state.name,
          email: this.props.email,
        })
          .then(res => {
            this.setState({
              spinning: false,
              paying: false,
              owing: `$${parseInt(res.amount).toFixed(2)} paid with card ${res.card}.`,
              negative: false,
            });
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          })
          .catch(err => {
            this.setState({
              spinning: false,
              paying: false,
              owing: `An error occurred, please try again.`,
            });
          });
      })
      .catch(err => {
        this.setState({
          spinning: false,
          paying: false,
          owing: `An error occurred, please try again.`,
        });
      });

    // However, this line of code will do the same thing:
    // this.props.stripe.createToken({type: 'card', name: 'Jenny Rosen'});
  };

  requestFinancing = () => {
    this.setState({spinning: true})
    this.props.client
      .mutate({
        mutation: REQUEST_FINANCING,
        variables: {
          amount: this.props.amount
        }
      })
      .then((res) => {
        this.setState({
          spinning: false,
          paying: false,
          financing: true,
          owing: res.data.requestFinancing.success ? `Your request has been submitted to our team.\nPlease allow 1-2 business days for processing.` : `An error occurred, please try again.`
        });
      })
      .catch(err => {
        this.setState({
          spinning: false,
          paying: false,
          financing: false,
          owing: `An error occurred, please try again.`,
        });
      });
  }

  togglePayState = () => {
    this.setState({ paying: !this.state.paying });
  };

  render() {
    const { amount } = this.props;
    const {
      partial,
      partialAmount,
      paying,
      spinning
    } = this.state;
    return (
      <Query
        query={gql`
          query CurrentUser {
            currentUser {
              id
              email
              firstName
              lastName
            }
          }
        `}>
        {({ loading, error, data }) => {
          if (loading) return <Loading size="3x" />;
          return (
            <Fragment>
              {this.state.spinning ? (
                <div className="load-spinner">
                  <Loading size="3x" />
                </div>
              ) : null}
              <form
                className="payments__stripe--form"
                onSubmit={this.handleSubmit}
                style={{
                  visibility: this.state.spinning ? 'hidden' : 'visible',
                  position: this.state.spinning ? 'absolute' : 'static',
                }}>
                <div className="payments__stripe--title">{this.state.owing}</div>
                {paying && !spinning ? 
                <div className="payments__stripe--title" style={{display: "flex", width: "100%", justifyContent: "center", margin: "0 0 0.5em 0"}}>
                  <div style={{display: "flex", alignItems: "flex-end", justifyContent: "flex-end"}}><strong>Payment Amount: $</strong></div>{partial ? 
                  <div style={{maxWidth: "5em"}}>
                    <TextField 
                      width="100%"
                      placeholder={amount.toFixed(2)}
                      value={partialAmount}
                      style={{textAlign: "right"}}
                      // error={amount < partialAmount ? "The amount you have entered is larger than owed" : null}
                      onChange={e => {
                        if (/[0-9]+(\.[0-9]{1,2})?/.test(e.target.value) || e.target.value.length === 0) {
                          this.setState({partialAmount: e.target.value})
                        }
                      }} 
                    />
                  </div>
                  : <div>{amount.toFixed(2)}</div>}
                </div> : null}
                {paying ? <a href="javascript:void(0)" style={{color: "#414141", fontSize: "12px", marginBottom: "0.5em", textDecoration: "underline"}} onClick={() => this.setState({partial: !partial, partialAmount: null})}>{partial ? "Cancel" : "Partial Payment"}</a> : null}
                {partial || !paying || amount < 1000 ? null : <a href="javascript:void(0)" style={{color: "#414141", fontSize: "12px", marginBottom: "0.5em", textDecoration: "underline"}} onClick={this.requestFinancing}>Request Financing</a>}
                {this.state.paying ? (
                  <div className="payments__stripe--info">
                    <div>
                      <CardSection />
                    </div>
                    <div className="payments__stripe--buttons-container">
                      <Button
                        className="payments__stripe--button"
                        fullWidth
                        onClick={this.togglePayState}
                        label="Cancel"
                        color="#414141"
                        style={{
                          display: this.state.spinning ? 'none' : 'block',
                        }}
                      />
                      <Button
                        fullWidth
                        className="payments__stripe--button"
                        label="Confirm"
                        style={{
                          display: this.state.spinning ? 'none' : 'block',
                        }}
                      />
                    </div>
                  </div>
                ) : null}
                {'\n'}
                {this.state.paying || !this.state.negative ? null : this.state.financing ? 
                  <div style={{ width: "100%", display: "flex", justifyContent: "space-around" }}>
                    <Button
                      style={{ width: "90px" }}
                      className="payments__stripe--button payments__stripe--button--wide"
                      label="Okay"
                      onClick={this.props.onClick}
                    />
                  </div> : (
                  <div style={{width: "100%", display: "flex", justifyContent: "space-around"}}>
                    <Button
                      style={{width: "90px"}}
                      className="payments__stripe--button payments__stripe--button--wide"
                      label="Cancel"
                      color="#414141"
                      onClick={this.props.onClick}
                    />
                    <Button style={{width: "90px"}} className="payments__stripe--button payments__stripe--button--wide" label="Pay" onClick={this.togglePayState} />
                  </div>
                )}
              </form>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

const REQUEST_FINANCING = gql`
  mutation requestFinancing($amount: Float!) {
    requestFinancing(amount: $amount) {
      success
    }
  }
`

export default withApollo(injectStripe(CheckoutForm));



// WEBPACK FOOTER //
// ./src/components/NewPayments/CheckoutForm.js